import { render, staticRenderFns } from "./ListFakeUsers.vue?vue&type=template&id=00dec3fe&scoped=true"
import script from "./ListFakeUsers.vue?vue&type=script&lang=js"
export * from "./ListFakeUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dec3fe",
  null
  
)

export default component.exports